// extracted by mini-css-extract-plugin
export default {"text":"CompanyManageExpiredEditPopup_text__FYVW7","field":"CompanyManageExpiredEditPopup_field__4L4qC"};